import './Referral.scss'

import React, {Component} from 'react';

import { push } from 'react-router-redux'
import { Image } from 'react-bootstrap'
import { show as showModal } from 'redux-modal'
import moment from 'moment-timezone'
import cx from 'bem-classnames'
import ShowMore from 'react-show-more'

import ReferralContact from './ReferralContact'
import PropertyInquiryModule from './PropertyInquiryModule'
import BrandingCard from 'common/views/components/BrandingCard'
import ReferralAgentSuccessHeader from 'manager/common/AgentSuccess'
import { ReferralEditDrawer } from 'manager/views/components/Referral/ReferralEditDrawer'
import { ReferralHeader } from './ReferralHeader'
import { ReferralHoldReleaseDrawer } from 'manager/views/components/ReferralStatus/ReferralHoldReleaseDrawer'
import { ReferralStatusUpdateBar } from 'manager/views/components/ReferralStatus/ReferralStatusUpdateBar'
import { ReferralStatusUpdateDrawer } from 'manager/views/components/ReferralStatus/ReferralStatusUpdateDrawer'
import { ReferralNoteBox } from 'manager/views/components/Referral/ReferralNoteBox'
import { isHeaderHidden, isEmbedded } from 'common/util/features'
import { debounce } from 'lodash'

import { setTitle } from 'common/redux/root'

import { fetchReferral } from 'manager/redux/referral'

import { updateNote, saveStatus } from 'manager/redux/referral_status'

import {
  LEAD_TYPE, DISPLAY_PRICE, ASSIGNMENT_AGENT_STATUS, LOAN_ASSIGNMENT_STATUS,
  LOCATION, MOTIVATION_CATEGORY, FINANCING_CATEGORY_SIMPLIFIED, TRANSACTION_TYPE,
  PROPERTY_TYPE, AGENT_STATUS_NEW, AGENT_STATUS_SPOKE, AGENT_STATUS_MET, AGENT_STATUS_CONTRACT, AGENT_STATUS_CLOSED,
  AGENT_STATUS_CONFIRMED_CLOSED, AGENT_SUCCESS_TOUCH_STAGES,
} from 'common/constants'

import { labelFor, newlineToBreak, getHumanReadableLeadAvailability, numberToCurrency } from 'common/util/helper'
import PreApprovalAdModal from "manager/views/components/Partner/PreApprovalAd"

const PendingCloseHeader = () => {
  return <div className="PendingCloseHeader">
    <div className="PendingCloseHeader__lock"><i className="fa fa-lock"/></div>
    <div className="PendingCloseHeader__message">
      <div className="PendingCloseHeader__title">Close Pending</div>
      <div className="PendingCloseHeader__text">You&apos;ll receive credit once the close is confirmed.</div>
    </div>
  </div>
}

const PAYMENT_PORTAL_URL = _.get(window, 'OD.initialState.env_config.RCC_PAYMENT_PORTAL_URL', 'https://moveinc.my.site.com/RealtorReferral/s/')
const PAYMENT_FAQ_URL = 'https://support.realtor.com/s/article/closing-payment-and-documents-frequently-asked-questions-free-tools'

const ReferralClosingInfo = ({ referral }) => {
  const { external_transaction_id } = referral

  return (
    <div>
      <div className="ReferralSectionHeader">
        <div>What Should I Do Next?</div>
      </div>
      <div className="ReferralClosingInfo">
        {external_transaction_id && (
          <div className="ReferralClosingInfo__header-centered">
            <span>TRANSACTION ID: </span>
            <span>{ external_transaction_id }</span>
          </div>
        )}
        <div className="ReferralClosingInfo__section">
          <div className="ReferralClosingInfo__icon"><i className="fa fa-globe"/></div>
          <div className="ReferralClosingInfo__content">
            <div className="ReferralClosingInfo__header">Go to our payment portal to:</div>
            <ol className="ReferralClosingInfo__portal-list">
              <li>Upload closing documents</li>
              <li>Pay referral fees</li>
            </ol>
          </div>
        </div>
        <a
          className="ReferralClosingInfo__portal-button"
          href={PAYMENT_PORTAL_URL}
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa fa-external-link" aria-hidden="true"/> Go to payment portal
        </a>
        <div className="ReferralClosingInfo__learn-more">
          Want other ways to pay? <a href={PAYMENT_FAQ_URL} rel="noopener noreferrer" target="_blank">Learn more</a>
        </div>
      </div>
    </div>
  )
}

class ReferralQuestionBox extends Component {
  constructor(props) {
    super(props)
    this.state = this.boxLogic.bind(this)()
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.dispatch(push({
      pathname:`/referral/${this.props.params.hash}`,
      query:{add: true, type: this.state.yesActionType}
    }))
  }

  boxLogic() {
    let referral = this.props.referral
    let questionText
    let yesActionType

    // If investor check for additional properties
    // If buy + not a related sell - show sell
    // If sell + not related buy - show buy
    switch (referral.client_category) {
      case 'investor':
        questionText = 'Have you made additional property purchases with this client?'
        yesActionType = (referral.transaction_type === 'buy') ? 'buy' : 'list'
        break;
      default:
        questionText = (referral.transaction_type === 'buy') ? 'Is this referral also selling a property?' : 'Is this referral also buying a property?'
        yesActionType = (referral.transaction_type === 'buy') ? 'list' : 'buy'
    }
    return {
      questionText: questionText,
      yesActionType: yesActionType
    }
  }

  render() {
    return (
      this.props.referral.show_additional_transaction_box ? <div className="QuestionBox">
        <div className="QuestionBox__row">
          <div>{this.state.questionText}</div>
        </div>
        <div className="QuestionBox__responses">
          <div onClick={this.handleClick}><a><i className="fa fa-plus" aria-hidden="true"/> Add Transaction</a></div>
        </div>
      </div> : null
    )
  }
}

export class ReferralDetails extends Component {

  constructor(props) {
    super(props)
    this.state = {
      metExpanded: false,
      rescheduleExpanded: false
    }

    this.meetingRef = null
    this.meetingNoteRef = null
  }

  componentDidMount() {
    const {referral, dispatch} = this.props
    const {has_active_digital_loan_assignment, is_preapproved} = referral
    if (has_active_digital_loan_assignment && is_preapproved) {
      dispatch(showModal("PreApprovalAdModal"))
    }
  }

  handleEdit = () => {
    const { dispatch, location } = this.props
    dispatch(push({
      pathname:`/referral/${this.props.params.hash}`,
      query: { ...location.query, edit: true },
    }))
  }

  handleMet = () => {
    this.setState({metExpanded: !this.state.metExpanded, rescheduleExpanded: false}, () => {
      if (this.state.metExpanded) {
        this.meetingRef.scrollIntoView()
        this.meetingNoteRef.focus()
      } else {
        this.props.dispatch(updateNote(''))
      }
    })
  }

  handleReschedule = () => {
    if (this.state.metExpanded) {
      this.props.dispatch(updateNote(''))
    }

    this.setState({rescheduleExpanded: !this.state.rescheduleExpanded, metExpanded: false})
  }

  handleMeetingNoteChange = (e) => {
    this.props.dispatch(updateNote(e.target.value))
  }

  handleMetSave = () => {
    const { dispatch, referralStatus } = this.props
    dispatch(saveStatus({
      action: 'update',
      status: AGENT_STATUS_MET,
      payload: { note: referralStatus.note },
    }))
  }

  debouncedHandleMetSave = debounce(this.handleMetSave, 5000, {leading: true, trailing: false})

  render() {
    const { referral, referralStatus, canUpdate, canUseInbox, canUseVoip } = this.props
    const {
      is_primary,
      is_lease,
      name,
      desc,
      note,
      max_budget,
      standard_max_budget,
      price_category,
      transaction_type,
      property_category,
      likelihood_category,
      financing_category,
      buyer_location,
      motivation_category,
      agent_status,
      meet_with_agent_at,
      property_inquiry_data = {},
      has_property,
      has_active_digital_loan_assignment,
      is_preapproved,
      pre_approval_amount,
      loan_broker_company,
    } = referral

    const { lead_availability } = property_inquiry_data

    let budgetLabel
    let budgetValue
    if (max_budget) {
      budgetLabel = 'Budget'
      budgetValue = standard_max_budget
    } else if (price_category) {
      budgetLabel = 'Price'
      budgetValue = labelFor(DISPLAY_PRICE, price_category)
    } else {
      budgetLabel = 'Budget'
      budgetValue = 'Unknown'
    }

    const leadAvailabilityNoProperty = agent_status === AGENT_STATUS_SPOKE && meet_with_agent_at && !has_property

    let financingLabel = labelFor(FINANCING_CATEGORY_SIMPLIFIED, financing_category)
    if (has_active_digital_loan_assignment && is_preapproved) {
      financingLabel = "Pre-approved"
      if (Number.isFinite(pre_approval_amount)) {
        financingLabel = `${financingLabel} for up to ${numberToCurrency(pre_approval_amount)}`
      }
      financingLabel = `${financingLabel} with ${loan_broker_company}`
    }

    return (
      <div>
        <div className="ReferralSectionHeader">
          <div onClick={canUpdate ? this.handleEdit : () => {}}>Transaction Details{ canUpdate && <i className="fa fa-pencil ReferralSectionHeader__pencil"/> }</div>
        </div>
        <div className="ReferralDetails">
          <div className="ReferralDetails__row" style={{marginTop: 0}}>
            { !is_lease && <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">Financing</div>
              <div className="ReferralDetails__value">{financingLabel}</div>
            </div> }
            <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">{ budgetLabel }</div>
              <div className="ReferralDetails__value">{ budgetValue }</div>
            </div>
            <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">Type</div>
              <div className="ReferralDetails__value">{ labelFor(TRANSACTION_TYPE, transaction_type) }</div>
            </div>
          </div>
          <div className="ReferralDetails__row">
            { lead_availability && !lead_availability.date && <div className="ReferralDetails__col-3">
             <div className="ReferralDetails__label">Availability</div>
             <div className="ReferralDetails__value">{getHumanReadableLeadAvailability(lead_availability)}</div>
           </div> }
            { is_primary && <div className="ReferralDetails__col-3">
                <div className="ReferralDetails__label">Timeframe</div>
                <div className="ReferralDetails__value">{ labelFor(LEAD_TYPE, likelihood_category) }</div>
              </div> }
          </div>
          <div className="ReferralDetails__row">
            { !is_lease && <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">Motivation</div>
              <div className="ReferralDetails__value">{ labelFor(MOTIVATION_CATEGORY, motivation_category) }</div>
            </div> }

            <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">Property Type</div>
              <div className="ReferralDetails__value">{ labelFor(PROPERTY_TYPE, property_category) }</div>
            </div>
          </div>
          <div className="ReferralDetails__row">
            <div className="ReferralDetails__col-3">
              <div className="ReferralDetails__label">Location</div>
              <div className="ReferralDetails__value">{ labelFor(LOCATION, buyer_location) }</div>
            </div>
          </div>
          { desc && <div className="ReferralDetails__row">
              <div className="ReferralDetails__col">
                <div className="ReferralDetails__label">Description</div>
                <div className="ReferralDetails__value">
                  <ShowMore lines={2} more='More' less='Less' anchorClass=''>{ desc }</ShowMore>
                </div>
              </div>
            </div> }
          { note && <div className="ReferralDetails__row">
              <div className="ReferralDetails__col">
                <div className="ReferralDetails__label">Note</div>
                <div className="ReferralDetails__value">
                  <ShowMore lines={2} more='More' less="Less" anchorClass=''>{ note }</ShowMore>
                </div>
              </div>
            </div> }
          <PropertyInquiryModule />
        </div>
        { leadAvailabilityNoProperty && <div className="ReferralDetails ReferralDetails__meet" ref={ref => this.meetingRef = ref}>
            <div className="ReferralDetails__row" style={{marginTop: 0}}>
              <div className="ReferralDetails__col">
                <div className="ReferralDetails__label">Client&#39;s Availability to Meet</div>
              </div>
            </div>
            <div className="ReferralDetails__row">
              <div className="ReferralDetails__col-2">
                <div className="ReferralDetails__meet-icon"><i className="fa fa-calendar"/></div>
                <div className="ReferralDetails__meet-value">
                  <div className="ReferralDetails__meet-value-top">{ moment(meet_with_agent_at).local().format('dddd') }</div>
                  <div className="ReferralDetails__meet-value-bottom">{ moment(meet_with_agent_at).local().format('MMMM DD, YYYY') }</div>
                </div>
              </div>
              <div className="ReferralDetails__col-2">
                <div className="ReferralDetails__meet-icon"><i className="fa fa-clock-o"/></div>
                <div className="ReferralDetails__meet-value">
                  <div className="ReferralDetails__meet-value-top">{ moment(meet_with_agent_at).local().format('h:mm A') }</div>
                  <div className="ReferralDetails__meet-value-bottom">{ moment.tz.guess() && moment.tz.zone(moment.tz.guess()) ? moment.tz.zone(moment.tz.guess()).abbrs[0] : null }</div>
                </div>
              </div>
            </div>
            <div className="ReferralDetails__row" style={{marginTop: 24}}>
              <div className="ReferralDetails__col-2">
                <div className={"ReferralDetails__meet-button" + (this.state.metExpanded ? " ReferralDetails__meet-selected" : "")} onClick={this.handleMet}>We Met</div>
              </div>
              <div className="ReferralDetails__col-2">
                <div className={"ReferralDetails__meet-button" + (this.state.rescheduleExpanded ? " ReferralDetails__meet-selected" : "")} onClick={this.handleReschedule}>Reschedule</div>
              </div>
            </div>
            { this.state.metExpanded && <div>
                <div className="ReferralDetails__meet-label">Great! Please share any additional notes.</div>
                <textarea className="ReferralDetails__meet-note" value={referralStatus.note} placeholder="Your note here..." onChange={this.handleMeetingNoteChange} ref={ref => this.meetingNoteRef = ref}/>
                <div className="ReferralDetails__meet-save" onClick={this.debouncedHandleMetSave}>Save</div>
              </div> }
            { this.state.rescheduleExpanded && <div>
                <div className="ReferralDetails__meet-label">How would you like to contact {name} to reschedule?</div>
                <div className="ReferralDetails__meet-contact">
                  <ReferralContact canUseInbox={canUseInbox} canUseVoip={canUseVoip} {...this.props}/>
                </div>
              </div> }
          </div> }
        <PreApprovalAdModal />
      </div>
    )
  }
}

export const ReferralVendorSection = ({ title, children }) => {
  return (
    <div>
      <div className="ReferralSectionHeader">
        <div>{title}</div>
      </div>
      <div className="ReferralDetails ReferralDetails__vendors">
        {children}
      </div>
    </div>
  )
}

export const ReferralLoanAssignment = (props) => {
  const hasDigitalAssignment = props.referral.has_active_digital_loan_assignment
  const hasTraditionalAssignment = props.referral.has_active_loan_assignment
  const hasAssignment = hasDigitalAssignment || hasTraditionalAssignment
  const optedOut = props.referral.has_loan_opt_out
  const needLender = props.referral.need_lender
  const isPreapproved = props.referral.is_preapproved
  const isPremium = props.referral.loan_broker_logo && !hasDigitalAssignment

  let lost = false
  let badgeStatus = null
  let opcityLenderStatus = 'Opcity Network Lender'
  let opcityStatusCls = 'ReferralDetails__vendor_status'
  let opcityStatusIcon = null

  if (hasDigitalAssignment) {
    opcityLenderStatus = 'Network Lender'
    if (isPreapproved) {
      badgeStatus = "Pre-Approved"
    }
  } else if (hasTraditionalAssignment) {
    if (optedOut) {
      opcityLenderStatus = 'Opted Out of Opcity Network Lender'
      opcityStatusCls += ' ReferralDetails__vendor_status--gray'
      opcityStatusIcon = <i className="fa fa-ban"/>
    } else if (isPreapproved) {
      opcityLenderStatus = 'Lender Has Pre-Approved Client'
      opcityStatusCls += ' ReferralDetails__vendor_status--green'
      opcityStatusIcon = <i className="fa fa-check"/>
    } else if (props.referral.lender_status) {
      lost = props.referral.lender_is_lost
      opcityLenderStatus = lost ? 'Officer No Longer Working With Client' : labelFor(LOAN_ASSIGNMENT_STATUS, props.referral.lender_status)
      opcityStatusCls += lost ? ' ReferralDetails__vendor_status--orange' : ' ReferralDetails__vendor_status--green'
      opcityStatusIcon = lost ? <i className="fa fa-ban"/> : <i className="fa fa-check"/>
    }
  }

  if (!hasAssignment && needLender) {
    return (
      <ReferralVendorSection title="Lender">
        <div className="ReferralDetails__need_lender ReferralDetails__value">
          <i className="fa fa-check"/> Received your request for a lender
        </div>
      </ReferralVendorSection>
    )
  }

  const referralLenderStatus = <div className={opcityStatusCls}>{opcityStatusIcon}{opcityLenderStatus}</div>
  const referralLenderCompany = (
    <div className={"ReferralDetails__company" + (optedOut ? " ReferralDetails__opt_out" : "")}>
      {props.referral.loan_broker_profile_name ? props.referral.loan_broker_profile_name : props.referral.loan_broker_company}
    </div>
  )

  return (
    <ReferralVendorSection title="Lender">
      { !hasAssignment && !optedOut && (
        <div className="ReferralDetails__label ReferralDetails__vendor_label">
          No Lender Assigned Yet
        </div>
      )}
      {(hasAssignment) && (
        <div onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/loan_details`}))}>
          {hasDigitalAssignment && (
            <div className="ReferralDetails__vendor ReferralDetails__vendor--digital">
              <div className="ReferralDetails__vendor_left">
                {props.referral.loan_broker_logo && <Image className="ReferralDetails__vendor_logo" src={props.referral.loan_broker_logo} />}
                <div className="ReferralDetails__vendor_text">
                  {referralLenderStatus}
                  {referralLenderCompany}
                </div>
              </div>
              {badgeStatus && (
                <div className="ReferralStatusBadges">
                  <span className="ReferralStatusBadges__badge">
                    { badgeStatus }
                  </span>
                </div>
              )}
              <i className={"fa fa-chevron-right ReferralDetails__indicator" + (optedOut ? " ReferralDetails__opt_out_indicator" : "")}/>
            </div>
          )}
          {!hasDigitalAssignment && (
            !isPremium || optedOut ? (
              <div className="ReferralDetails__vendor">
                {referralLenderStatus}
                {referralLenderCompany}
                <div className={"ReferralDetails__officer" + (optedOut ? " ReferralDetails__opt_out" : "")}>{props.referral.loan_officer_name}</div>
                <i className={"fa fa-chevron-right ReferralDetails__indicator" + (optedOut ? " ReferralDetails__opt_out_indicator" : "")}/>
              </div>
            ) : (
              <div className="ReferralDetails__value ReferralDetails__branding">
              {referralLenderStatus}
                <BrandingCard
                  logo={props.referral.loan_broker_logo}
                  company={props.referral.loan_broker_profile_name ? props.referral.loan_broker_profile_name : props.referral.loan_broker_company}
                  phone={props.referral.loan_broker_phone_formatted}
                  cardType="Lender"/>
                <i className="fa fa-chevron-right ReferralDetails__indicator"/>
              </div>
            )
          )}
        </div>
      )}
      { optedOut && (
            <div className="ReferralDetails__vendor" onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/other_loan_details`}))} style={{borderBottom: 0}}>
              <div className='ReferralDetails__vendor_status ReferralDetails__vendor_status--other'>Other Lender</div>
              <div className="ReferralDetails__company">{props.referral.loan_opt_out_company}</div>
              <div className="ReferralDetails__officer">{props.referral.loan_opt_out_officer}</div>
              <i className="fa fa-chevron-right ReferralDetails__indicator"/>
            </div>
      )}
      { !optedOut && (
          <div className={"ReferralDetails__sub_link ReferralDetails__vendor" + (isPremium ? " ReferralDetails__premium_vendor" : "")} onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/other_loan_details`}))} style={{borderBottom: 0}}>
            <a>
              <div className="ReferralDetails__sub_link--refer"><div></div></div>
              <div className="ReferralDetails__sub_link--text">Use another lender</div>
            </a>
            <i className="fa fa-chevron-right ReferralDetails__indicator"/>
          </div>
      )}
    </ReferralVendorSection>
  )
}

const QualiaProviderSelectionAndOrderStatus = (props)=> {

  let selected_settlement_provider = props.referral.selected_settlement_provider

  return (
    <ReferralVendorSection title="Title & Escrow">
      <div onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/title_and_escrow_details`}))}>
        { selected_settlement_provider &&
            <div className="ReferralDetails__vendor">
              <div className="ReferralDetails__company">{selected_settlement_provider.settlement_provider_name}</div>
            </div>
            }
        <div className="ReferralDetails__sub_link ReferralDetails__vendor" onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/title_and_escrow_details`}))} style={{borderBottom: 0}}>
          <a>
            <div className="ReferralDetails__sub_link--refer"><div></div></div>
            <div className="ReferralDetails__sub_link--text">{selected_settlement_provider ? "View details" : "Select provider"}</div>
          </a>
        </div>
      </div>
    </ReferralVendorSection>
  )
}

const ReferralSettlementAssignment = (props)=> {
  let hasAssignment = props.referral.has_active_settlement_assignment
  let optedOut = props.referral.has_settlement_opt_out
  const isPremium = props.referral.settlement_broker_logo
  let opcitySettlementStatus = 'Opcity Network Settlement Company'
  let opcityStatusCls = 'ReferralDetails__vendor_status'
  let opcityStatusIcon = null

  if (hasAssignment) {
    if (optedOut) {
      opcitySettlementStatus = 'Opted Out of Opcity Network Settlement Company'
      opcityStatusCls += ' ReferralDetails__vendor_status--gray'
      opcityStatusIcon = <i className="fa fa-ban"/>
    }
  }

  return (
    <ReferralVendorSection title="Settlement">
      {
        !hasAssignment && !optedOut ? <div className="ReferralDetails__label ReferralDetails__vendor_label">No Settlement Company Assigned Yet</div> : null
      }
      {
        hasAssignment ? (
          <div onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/settlement_details`}))}>
            {
              !isPremium || optedOut ? <div className="ReferralDetails__vendor">
                <div className={opcityStatusCls}>{opcityStatusIcon}{opcitySettlementStatus}</div>
                <div className={"ReferralDetails__company" + (optedOut ? " ReferralDetails__opt_out" : "")}>{props.referral.settlement_broker_profile_name ? props.referral.settlement_broker_profile_name : props.referral.settlement_broker_company}</div>
                <div className={"ReferralDetails__officer" + (optedOut ? " ReferralDetails__opt_out" : "")}>{props.referral.settlement_officer_name}</div>
                <i className={"fa fa-chevron-right ReferralDetails__indicator" + (optedOut ? " ReferralDetails__opt_out_indicator" : "")}/>
              </div> :
                <div className="ReferralDetails__value ReferralDetails__branding">
                  <div className={opcityStatusCls}>{opcityStatusIcon}{opcitySettlementStatus}</div>
                  <BrandingCard
                    logo={props.referral.settlement_broker_logo}
                    company={props.referral.settlement_broker_profile_name ? props.referral.settlement_broker_profile_name : props.referral.settlement_broker_company}
                    phone={props.referral.settlement_broker_phone_formatted}
                    cardType="Settlement Partner"/>
                  <i className="fa fa-chevron-right ReferralDetails__indicator"/>
                </div>

            }
          </div>
        ) : null
      }
      {
        optedOut ?
          <div className="ReferralDetails__vendor" onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/other_settlement_details`}))} style={{borderBottom: 0}}>
            <div className='ReferralDetails__vendor_status ReferralDetails__vendor_status--other'>Other Settlement Company</div>
            <div className="ReferralDetails__company">{props.referral.settlement_opt_out_company}</div>
            <div className="ReferralDetails__officer">{props.referral.settlement_opt_out_officer}</div>
            <i className="fa fa-chevron-right ReferralDetails__indicator"/>
          </div> :
          <div className={"ReferralDetails__sub_link ReferralDetails__vendor" + (isPremium ? " ReferralDetails__premium_vendor" : "")} onClick={() => props.dispatch(push({pathname:`/referral/${props.params.hash}/other_settlement_details`}))} style={{borderBottom: 0}}>
            <a>
              <div className="ReferralDetails__sub_link--refer"><div></div></div>
              <div className="ReferralDetails__sub_link--text">Use another settlement company</div>
            </a>
            <i className="fa fa-chevron-right ReferralDetails__indicator"/>
          </div>
      }
    </ReferralVendorSection>
  )
}

const ReferralStatus = (props) => {
  // const agent_note = <div className="ReferralStatus__note">
  //   <div className="ReferralStatus__label">Note</div>
  //   <div className="ReferralStatus__value">{ newlineToBreak(props.referral.agent_note) }</div>
  // </div>

  const classes = {
    name: 'ReferralStatus__status',
    modifiers: ['active', 'need-action']
  }

  function getStatus(currentStatus, key) {
    if (currentStatus === 'new' && key == 'spoke-to-client') return {'need-action':true}
    if (key === currentStatus) return {active:true}

    for (let i = 0; i<ASSIGNMENT_AGENT_STATUS.length; i++) {
      if (ASSIGNMENT_AGENT_STATUS[i].value === key) return {active:true}
      if (ASSIGNMENT_AGENT_STATUS[i].value === currentStatus) return {}
    }
    return {}
  }

  function getCircleClass(currentStatus, key) {
    let result = getStatus(currentStatus, key)
    return result.active ? "fa fa-circle" : "fa fa-circle-o"
  }

  function getTemperatureBarLength(currentStatus) {
    for (let i = 0; i<ASSIGNMENT_AGENT_STATUS.length; i++) {
      if (ASSIGNMENT_AGENT_STATUS[i].value === currentStatus) return {[String(i-1)]:true}
    }
    return {'0':true}
  }

  const tempClasses = {
    name: "ReferralStatus__temp-full",
    modifiers: ['1', '2', '3', '4'],
  }

  const statusList = !props.referral.is_lease ? <div className="ReferralStatus__status-list">
    <div className={cx(classes, getStatus(props.referral.agent_status, 'spoke-to-client'))}><i className={getCircleClass(props.referral.agent_status, 'spoke-to-client')} aria-hidden="true"></i>We Spoke<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'met-showing'))}><i className={getCircleClass(props.referral.agent_status, 'met-showing')} aria-hidden="true"></i>{ props.referral.transaction_type === 'list' ? 'We Met / Listed Home' : 'We Met / House Hunted' }<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'offers-made'))}><i className={getCircleClass(props.referral.agent_status, 'offers-made')} aria-hidden="true"></i>{ props.referral.transaction_type === 'list' ? 'We Received Offers' : 'We Made an Offer' }<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'contract'))}><i className={getCircleClass(props.referral.agent_status, 'contract')} aria-hidden="true"></i>We&#39;re Under Contract<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'closed'))}><i className={getCircleClass(props.referral.agent_status, 'closed')} aria-hidden="true"></i>We Closed<i className="fa fa-check" aria-hidden="true"></i></div>
  </div> : <div className="ReferralStatus__status-list">
    <div className={cx(classes, getStatus(props.referral.agent_status, 'spoke-to-client'))}><i className={getCircleClass(props.referral.agent_status, 'spoke-to-client')} aria-hidden="true"></i>We Spoke<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'met-showing'))}><i className={getCircleClass(props.referral.agent_status, 'met-showing')} aria-hidden="true"></i>Viewed Properties<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'offers-made'))}><i className={getCircleClass(props.referral.agent_status, 'offers-made')} aria-hidden="true"></i>Negotiating<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'contract'))}><i className={getCircleClass(props.referral.agent_status, 'contract')} aria-hidden="true"></i>Lease Signed<i className="fa fa-check" aria-hidden="true"></i></div>
    <div className={cx(classes, getStatus(props.referral.agent_status, 'closed'))}><i className={getCircleClass(props.referral.agent_status, 'closed')} aria-hidden="true"></i>Received My Commission<i className="fa fa-check" aria-hidden="true"></i></div>
  </div>

  return (
    <div>
      <div className="ReferralSectionHeader">
        <div>Status</div>
      </div>
      <div className="ReferralStatus">
        <div className="ReferralStatus__timeline">
          <div className="ReferralStatus__temp-empty"></div>
          <div className={cx(tempClasses, getTemperatureBarLength(props.referral.agent_status))}></div>
          { statusList }
        </div>
      </div>
    </div>
  )
}

class ReferralNotes extends Component {

  render() {
    let noteSection
    if (this.props.referral.legacy_note_style) {
      noteSection = <div className="ReferralNoteBox">
        <div className="note">{ newlineToBreak(this.props.referral.agent_note) }</div>
      </div>
    } else {
      noteSection = this.props.referral.assignment_transaction_history.map((ath, idx) => <ReferralNoteBox {...ath} referral={this.props.referral} key={idx} />)
    }

    return (
      <div className="ReferralStatus__history">
        { noteSection }
      </div>
    )
  }
}

class Referral extends Component {

  componentDidMount() {
    const { router, dispatch } = this.props

    dispatch(setTitle("My Referral"))
    const fetchReferralPromise = dispatch(fetchReferral(this.props.params.hash, true))

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage && isHeaderHidden()) {
      setTimeout(() => window.ReactNativeWebView.postMessage('referral'))
    }

    if (isEmbedded()) {
      const currentLocation = router.getCurrentLocation()
      router.replace({ ...currentLocation, state: { dismiss: true }})
      router.push({ ...currentLocation, state: { dismiss: false }})

      router.listen(({ action, state = {} } = {}) => {
        if (action === 'POP' && state.dismiss) {
          window.ReactNativeWebView.postMessage('dismiss')
        }
      })
    }

    return fetchReferralPromise
  }

  render() {
    const { referral, auth, canUseInbox, canUseVoip, location } = this.props

    if (!referral) {
      return null
    }

    const { agent_historical_assigned_count, agent_note, agent_status, assignment_transaction_history, is_lease, is_holding, is_mvip_assignment } = referral

    const isAddTransaction = location && location.query && location.query.add
    const admin_user = _.get(auth, ['user', 'admin_user'])
    const canUpdate = ![AGENT_STATUS_CLOSED, AGENT_STATUS_CONFIRMED_CLOSED].includes(agent_status) || admin_user || isAddTransaction
    const isPendingClose = agent_status === AGENT_STATUS_CLOSED && !is_mvip_assignment
    const showFirstAssignmentHeader = (agent_historical_assigned_count === 1) && [AGENT_STATUS_NEW, AGENT_STATUS_SPOKE].includes(agent_status) && !is_holding

    return (
      <div className="Referral">
        { showFirstAssignmentHeader &&
          <ReferralAgentSuccessHeader stage={AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL} />
        }
        { isPendingClose && <PendingCloseHeader /> }
        <ReferralHeader canUseInbox={canUseInbox} canUseVoip={canUseVoip} {...this.props} />
        { (agent_status === AGENT_STATUS_CLOSED || agent_status === AGENT_STATUS_CONTRACT) && !is_mvip_assignment && <ReferralClosingInfo {...this.props} /> }
        <ReferralQuestionBox {...this.props} />
        <ReferralDetails canUpdate={canUpdate} canUseVoip={canUseVoip} {...this.props} />
        { canUpdate && !is_lease && <ReferralLoanAssignment {...this.props} /> }
        { canUpdate && !is_lease && !referral.qualia_title_enabled && <ReferralSettlementAssignment {...this.props} /> }
        { canUpdate && !is_lease && referral.qualia_title_enabled && <QualiaProviderSelectionAndOrderStatus {...this.props} /> }
        <ReferralStatus {...this.props} />
        { (agent_note || assignment_transaction_history.length > 0) && (
          <div>
            <div className="ReferralSectionHeader">
              <div>Notes</div>
            </div>
            <div className="ReferralStatus no-bottom-border">
              <ReferralNotes {...this.props} />
            </div>
          </div>
        )}
        { canUpdate && <ReferralStatusUpdateBar /> }
        { canUpdate && <ReferralStatusUpdateDrawer /> }
        { canUpdate && (
          <ReferralHoldReleaseDrawer />
        )}
        { canUpdate && <ReferralEditDrawer {...this.props} /> }
      </div>
    )
  }
}

export default Referral
